import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Logo } from '../../components/Logo';
import { PrefsSwitcher } from '../../components/PrefsSwitcher';
import { useT } from '../../i18n/i18n';
import styles from './AuthLayout.module.css';

export function AuthLayout({
  title,
  subtitle,
  children,
}: {
  title: string;
  subtitle?: string;
  children: ReactNode;
}) {
  const t = useT();
  return (
    <div className={styles.layout}>
      <main className={styles.main}>
        <div className={styles.top}>
          <Link to="/" aria-label="miroom">
            <Logo />
          </Link>
          <PrefsSwitcher />
        </div>
        <div className={styles.formWrap}>
          <div className={styles.card}>
            <div>
              <h1 className={styles.title}>{title}</h1>
              {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
            </div>
            {children}
          </div>
        </div>
      </main>
      <aside className={styles.aside} aria-hidden="true">
        <div className={styles.notes}>
          <div className={styles.note1}>{t('auth.note1')}</div>
          <div className={styles.note2}>{t('auth.note2')}</div>
          <div className={styles.note3}>{t('auth.note3')}</div>
        </div>
        <h2>{t('auth.asideTitle')}</h2>
        <p>{t('auth.asideText')}</p>
      </aside>
    </div>
  );
}
